import { render, staticRenderFns } from "./LayoutWdmaHist.vue?vue&type=template&id=0361741d"
import script from "./LayoutWdmaHist.vue?vue&type=script&lang=js"
export * from "./LayoutWdmaHist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports